;(function (root, factory) {
  const api = factory();
  if (typeof module === "object" && module.exports) {
    module.exports = api;
  }
  root.PawmoryProductWizard = api;
})(typeof window !== "undefined" ? window : globalThis, function () {
  function decodeHtmlEntities(value) {
    return String(value ?? "")
      .replace(/&amp;/g, "&")
      .replace(/&#39;|&#x27;/gi, "'")
      .replace(/&quot;/g, '"');
  }

  function escapeHtml(value) {
    return decodeHtmlEntities(value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function readTranslation(source, key, fallback) {
    if (!source || !key) return fallback;
    const value = key.split(".").reduce(function (accumulator, part) {
      return accumulator && typeof accumulator === "object" ? accumulator[part] : undefined;
    }, source);
    return value == null || value === "" ? fallback : value;
  }

  function renderStepButtons(steps, activeStep) {
    return steps.map(function (label, index) {
      const stateClass = index === activeStep ? " is-active" : index < activeStep ? " is-done" : "";
      return (
        '<button class="pw-step' +
        stateClass +
        '" data-step="' +
        index +
        '" type="button">' +
        '<span class="pw-step__dot">' +
        (index + 1) +
        "</span>" +
        '<span class="pw-step__label">' +
        escapeHtml(label) +
        "</span>" +
        "</button>"
      );
    }).join("");
  }

  function renderFrames(frames, state) {
    return frames.map(function (frame, index) {
      const isSelected = (state.frame || "") === frame.name;
      return (
        '<button class="pw-card pw-frame-card' +
        (isSelected ? " is-selected" : "") +
        '" data-frame="' +
        escapeHtml(frame.name) +
        '" type="button">' +
        '<span class="pw-card__media"><img src="' +
        escapeHtml(frame.image || "") +
        '" alt="' +
        escapeHtml(frame.name) +
        '" loading="' +
        (index === 0 ? "eager" : "lazy") +
        '"></span>' +
        '<span class="pw-card__title-row">' +
        '<span class="pw-card__title">' +
        escapeHtml(frame.name) +
        "</span>" +
        (frame.tag ? '<span class="pw-card__tag">' + escapeHtml(frame.tag) + "</span>" : "") +
        "</span>" +
        '<span class="pw-card__meta">' +
        escapeHtml(frame.upcharge || "") +
        "</span>" +
        "</button>"
      );
    }).join("");
  }

  function renderBackgrounds(backgrounds, state) {
    return backgrounds.map(function (background) {
      const isSelected = (state.background || "") === background.name;
      return (
        '<button class="pw-swatch' +
        (isSelected ? " is-selected" : "") +
        '" data-background="' +
        escapeHtml(background.name) +
        '" type="button">' +
        '<span class="pw-swatch__swatch" style="--swatch:' +
        escapeHtml(background.hex || "#f0ede7") +
        '"></span>' +
        '<span class="pw-swatch__thumb" style="--swatch:' +
        escapeHtml(background.hex || "#f0ede7") +
        '"></span>' +
        '<span class="pw-swatch__label">' +
        escapeHtml(background.name) +
        "</span>" +
        "</button>"
      );
    }).join("");
  }

  function renderAccessories(accessories, state) {
    const activeExtras = Array.isArray(state.extras) ? state.extras : [];
    return accessories.map(function (item) {
      const accessoryKey = item.key || item.name;
      const selected = item.selected || activeExtras.indexOf(accessoryKey) >= 0;
      const disabled = Boolean(item.disabled);
      return (
        '<label class="pw-accessory' +
        (selected ? " is-selected" : "") +
        (disabled ? " is-disabled" : "") +
        '">' +
        '<span class="pw-accessory__check">' +
        '<input type="checkbox" data-accessory="' +
        escapeHtml(accessoryKey) +
        '"' +
        (selected ? " checked" : "") +
        (disabled ? " disabled" : "") +
        ">" +
        '<span class="pw-accessory__fake"></span>' +
        "</span>" +
        '<span class="pw-accessory__content">' +
        '<span class="pw-accessory__title-row">' +
        '<span class="pw-accessory__title">' +
        escapeHtml(item.name) +
        "</span>" +
        (item.priceLabel ? '<span class="pw-accessory__price">' + escapeHtml(item.priceLabel) + "</span>" : "") +
        "</span>" +
        (item.inputPlaceholder && item.selected
          ? '<input class="pw-accessory__input" type="text" placeholder="' +
            escapeHtml(item.inputPlaceholder) +
            '" value="' +
            escapeHtml(state.petName || "") +
            '"' +
            (disabled ? " disabled" : "") +
            ">"
          : "") +
        (disabled
          ? '<span class="pw-accessory__note">' +
            escapeHtml(item.disabledLabel || "Unavailable right now") +
            "</span>"
          : "") +
        "</span>" +
        "</label>"
      );
    }).join("");
  }

  function renderDigitalToggle(config) {
    const selected = typeof config === "object" ? Boolean(config.selected) : Boolean(config);
    const disabled = Boolean(config && typeof config === "object" && config.disabled);
    const priceLabel =
      config && typeof config === "object" && config.priceLabel
        ? config.priceLabel
        : "";
    const disabledLabel =
      config && typeof config === "object" && config.disabledLabel
        ? config.disabledLabel
        : "Unavailable right now";
    const title =
      config && typeof config === "object" && config.title
        ? config.title
        : "Digital Download of Your Artwork";
    const subtitle =
      config && typeof config === "object" && config.subtitle
        ? config.subtitle
        : "Perfect for sharing and setting as your smartphone wallpaper";
    return (
      '<label class="pw-digital-toggle pw-accessory' +
      (selected ? ' is-selected' : '') +
      (disabled ? ' is-disabled' : '') +
      '">' +
      '<span class="pw-accessory__check">' +
      '<input id="pw-digital-download" type="checkbox"' +
      (selected ? " checked" : "") +
      (disabled ? " disabled" : "") +
      ">" +
      '<span class="pw-accessory__fake"></span>' +
      "</span>" +
      '<span class="pw-accessory__content pw-digital-toggle__copy">' +
      '<span class="pw-accessory__title-row pw-digital-toggle__title-row">' +
      '<span class="pw-accessory__title">' + escapeHtml(title) + "</span>" +
      (priceLabel ? '<span class="pw-accessory__price pw-digital-toggle__price">' + escapeHtml(priceLabel) + "</span>" : "") +
      "</span>" +
      "<small>" + escapeHtml(subtitle) + "</small>" +
      (disabled ? '<span class="pw-accessory__note pw-digital-toggle__note">' + escapeHtml(disabledLabel) + "</span>" : "") +
      "</span>" +
      "</label>"
    );
  }

  function renderBackButton(activeStep, attributeName) {
    return (
      '<button class="pw-footer-bar__back" type="button" ' +
      attributeName +
      (activeStep > 0 ? "" : " hidden") +
      ' aria-label="Go back">' +
      '<svg viewBox="0 0 24 24" focusable="false" aria-hidden="true"><path d="M14.5 6.5 9 12l5.5 5.5" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      "</button>"
    );
  }

  function renderPanelFooter(actionLabel, priceHtml, activeStep) {
    return (
      '<div class="pw-footer-bar">' +
      '<div class="pw-footer-bar__price">' +
      priceHtml +
      "</div>" +
      '<div class="pw-footer-bar__actions">' +
      renderBackButton(activeStep, 'data-step-back') +
      '<button class="pw-footer-bar__next button button--primary" type="button">' +
      escapeHtml(actionLabel) +
      "</button>" +
      "</div>" +
      "</div>"
    );
  }

  function renderWizardMarkup(config) {
    const state = config && config.state ? config.state : {};
    const options = config && config.options ? config.options : {};
    const translations = options.translations || {};
    const steps = options.steps || ["Frame", "Background", "Accessory", "Upload", "Extra"];
    const priceHtml = config && config.priceHtml ? config.priceHtml : "";
    const frameDetailsText = options.frameDetailsText || "";
    const guideImage = options.photoGuideImage || "";
    const guideTitle = options.photoGuideTitle || readTranslation(translations, "photoGuide.title", "Photo Guide");
    const guideBody = options.photoGuideBody || readTranslation(translations, "photoGuide.body", "Follow the tips below when taking your pet's photo! If you aren't able to follow these steps exactly, don't worry! We have a dedicated team who check all orders and photos as they come in.");
    const guideTips = options.photoGuideTips || [];
    const skipImage = options.skipUploadImage || "";
    const skipTitle = options.skipUploadTitle || readTranslation(translations, "skipUpload.title", "No photo right now?");
    const skipLead = options.skipUploadLead || readTranslation(translations, "skipUpload.lead", "No problem!");
    const skipBody = options.skipUploadBody || readTranslation(translations, "skipUpload.body", "We'll send you an email to send us the photo(s) when you're ready. Or you can upload now.");
    const uploadHelperText = options.uploadHelperText || readTranslation(translations, "upload.helperText", "Upload pet photos");
    const allStepsComplete = Boolean(options.allStepsComplete);
    const continueLabel = readTranslation(translations, "buttons.continue", "Continue");
    const addToCartLabel = readTranslation(translations, "buttons.addToCart", "Add to Cart");
    const uploadPhotosLabel = readTranslation(translations, "buttons.uploadPhotos", "Upload Photos");
    const viewGuidesLabel = readTranslation(translations, "buttons.viewPhotoGuides", "View photo guides");
    const uploadNowLabel = readTranslation(translations, "buttons.uploadNow", "Upload photo(s) now");
    const sendLaterLabel = readTranslation(translations, "buttons.sendLater", "Send photo(s) later");
    const closeLabel = readTranslation(translations, "buttons.close", "Close");
    const notesLabel = readTranslation(translations, "notes.label", "Note");
    const notesPlaceholder = readTranslation(translations, "notes.placeholder", "Anything special to include?");
    const panelFrameTitle = readTranslation(translations, "stepTitles.frame", "Step 1 - Choose Frame");
    const panelBackgroundTitle = readTranslation(translations, "stepTitles.background", "Step 2 - Choose Background");
    const panelAccessoriesTitle = readTranslation(translations, "stepTitles.accessories", "Step 3 - Choose Accessories");
    const panelUploadTitle = readTranslation(translations, "stepTitles.upload", "Step 4 - Upload Photos");
    const panelExtrasTitle = readTranslation(translations, "stepTitles.extras", "Step 5 - Extras");
    const mobileButtonLabel = allStepsComplete ? addToCartLabel : continueLabel;

    const uploadPlaceholderMarkup =
      '<div class="pw-upload-list__empty">' +
      '<button class="pw-upload-list__placeholder" type="button" data-upload-placeholder-trigger>' +
      '<span class="pw-upload-list__placeholder-icon" aria-hidden="true">' +
      '<svg viewBox="0 0 24 24" focusable="false"><path d="M12 16V7.5M8.5 11 12 7.5 15.5 11M6 16.5v1a1.5 1.5 0 0 0 1.5 1.5h9a1.5 1.5 0 0 0 1.5-1.5v-1" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '</span>' +
      '<span class="pw-upload-list__placeholder-text">' + escapeHtml(uploadHelperText) + '</span>' +
      '</button>' +
      '</div>';

    return (
      '<section class="pwz" data-wizard-anchor>' +
      '<div class="pw-stepper-banner">' +
      '<div class="pwz-steps">' +
      renderStepButtons(steps, state.activeStep || 0) +
      "</div>" +
      "</div>" +
      '<p class="pw-status-banner" id="pw-status-banner" hidden></p>' +
      '<div class="pw-panels">' +
      '<section class="pw-panel is-active" data-panel="frame">' +
      '<div class="pw-panel__header"><div class="pw-panel__title-row"><p class="pw-panel__eyebrow">' + escapeHtml(panelFrameTitle) + '</p></div></div>' +
      '<div class="pw-card-grid">' +
      renderFrames(options.frames || [], state) +
      "</div>" +
      (frameDetailsText
        ? '<p class="pw-frame-details">' + escapeHtml(frameDetailsText) + "</p>"
        : "") +
      renderPanelFooter(continueLabel, priceHtml, state.activeStep || 0) +
      "</section>" +
      '<section class="pw-panel" data-panel="background">' +
      '<div class="pw-panel__header"><div class="pw-panel__title-row"><p class="pw-panel__eyebrow">' + escapeHtml(panelBackgroundTitle) + '</p></div></div>' +
      '<div class="pw-swatch-grid">' +
      renderBackgrounds(options.backgrounds || [], state) +
      "</div>" +
      renderPanelFooter(continueLabel, priceHtml, state.activeStep || 0) +
      "</section>" +
      '<section class="pw-panel" data-panel="accessory">' +
      '<div class="pw-panel__header"><div class="pw-panel__title-row"><p class="pw-panel__eyebrow">' + escapeHtml(panelAccessoriesTitle) + '</p></div></div>' +
      '<div class="pw-accessory-list">' +
      renderAccessories(options.accessories || [], state) +
      "</div>" +
      renderPanelFooter(continueLabel, priceHtml, state.activeStep || 0) +
      "</section>" +
      '<section class="pw-panel" data-panel="upload">' +
      '<div class="pw-panel__header"><div class="pw-panel__title-row"><p class="pw-panel__eyebrow">' + escapeHtml(panelUploadTitle) + '</p></div></div>' +
      '<div class="pw-upload-dropzone">' +
      '<div class="pw-upload-list" id="pw-upload-list">' + uploadPlaceholderMarkup + '</div>' +
      '<div class="pw-upload-dropzone__control">' +
      '<button class="pw-upload-dropzone__button" type="button" data-upload-trigger>' + escapeHtml(uploadPhotosLabel) + '</button>' +
      '<input id="pw-upload-input" class="pw-upload-input" type="file" accept="image/*" multiple aria-label="' + escapeHtml(uploadPhotosLabel) + '">' +
      '</div>' +
      '<button class="pw-upload-dropzone__guide-link" type="button">' + escapeHtml(viewGuidesLabel) + '</button>' +
      "</div>" +
      renderPanelFooter(continueLabel, priceHtml, state.activeStep || 0) +
      "</section>" +
      '<section class="pw-panel" data-panel="extra">' +
      '<div class="pw-panel__header"><div class="pw-panel__title-row"><p class="pw-panel__eyebrow">' + escapeHtml(panelExtrasTitle) + '</p></div></div>' +
      renderDigitalToggle({
        selected: Boolean(state.digitalDownload),
        priceLabel: options.digitalPriceLabel,
        disabled: Boolean(options.digitalDisabled),
        disabledLabel: options.digitalDisabledLabel,
        title: readTranslation(translations, "digital.title", "Digital Download of Your Artwork"),
        subtitle: readTranslation(translations, "digital.subtitle", "Perfect for sharing and setting as your smartphone wallpaper")
      }) +
      '<div class="pw-copy-fields">' +
      '<label class="pw-copy-fields__field"><span>' + escapeHtml(notesLabel) + '</span><textarea id="pw-notes" rows="4" placeholder="' + escapeHtml(notesPlaceholder) + '">' +
      escapeHtml(state.notes || "") +
      "</textarea></label>" +
      "</div>" +
      renderPanelFooter(addToCartLabel, priceHtml, state.activeStep || 0) +
      "</section>" +
      "</div>" +
      '<div class="pw-mobile-sticky-bar" data-mobile-sticky-bar>' +
      '<div class="pw-mobile-sticky-bar__price">' +
      priceHtml +
      "</div>" +
      '<div class="pw-mobile-sticky-bar__actions">' +
      '<button class="pw-mobile-sticky-bar__button button button--primary" type="button" data-mobile-sticky-action>' +
      escapeHtml(mobileButtonLabel) +
      "</button>" +
      "</div>" +
      "</div>" +
      '<button class="pw-desktop-return-cta" type="button" data-desktop-return-cta hidden>Customize Yours</button>' +
      '<div class="pw-upload-modal" hidden>' +
      '<div class="pw-upload-modal__dialog">' +
      '<button class="pw-upload-modal__close" type="button" aria-label="' + escapeHtml(closeLabel) + '">×</button>' +
      '<div class="pw-upload-modal__body"><h4>' +
      escapeHtml(guideTitle) +
      "</h4><p>" +
      escapeHtml(guideBody) +
      '</p><ul class="pw-upload-modal__tips">' +
      guideTips.map(function (tip) { return "<li>" + escapeHtml(tip) + "</li>"; }).join("") +
      '</ul></div>' +
      '<div class="pw-upload-modal__media"><img src="' +
      escapeHtml(guideImage) +
      '" alt="' +
      escapeHtml(guideTitle) +
      '"></div></div></div>' +
      '<div class="pw-skip-upload-modal" hidden>' +
      '<div class="pw-skip-upload-modal__dialog">' +
      '<button class="pw-skip-upload-modal__close" type="button" aria-label="' + escapeHtml(closeLabel) + '">×</button>' +
      '<div class="pw-skip-upload-modal__media"><img src="' +
      escapeHtml(skipImage) +
      '" alt="' +
      escapeHtml(skipTitle) +
      '"></div>' +
      '<div class="pw-skip-upload-modal__body"><h4>' +
      escapeHtml(skipTitle) +
      "</h4><p><strong>" +
      escapeHtml(skipLead) +
      "</strong></p><p>" +
      escapeHtml(skipBody) +
      '</p><div class="pw-skip-upload-modal__actions"><button class="pw-secondary-btn" type="button" data-skip-upload-action="upload">' + escapeHtml(uploadNowLabel) + '</button><button class="pw-primary-btn" type="button" data-skip-upload-action="later">' + escapeHtml(sendLaterLabel) + '</button></div></div></div></div>' +
      "</section>"
    );
  }

  return { renderWizardMarkup: renderWizardMarkup };
});
